import { ProfileService, AuthService } from '@outlaw/core';
import { map, switchMap, tap } from 'rxjs/operators';
import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isGuestToken } from '../util';
import { ExternalApiService } from '@outlaw/core';

// todo: refactor to service
export const userProfileUpdateResolver: ResolveFn<Observable<boolean>> = () => {
  const profileService = inject(ProfileService);
  const authService = inject(AuthService);
  const externalApiService = inject(ExternalApiService);

  let userToken = profileService.getUserToken();

  if (!userToken) {
    return of(false);
  }

  if (isGuestToken(userToken)) {
    // Argo Guest Token
    return of(false);
  }

  return authService.getUserData().pipe(
    tap((userData) => profileService.updateUserData(userData)),
    switchMap(() => externalApiService.synchronizeExternalServices()),
    map((userData) => !!userData),
  );
};
